<template lang="html">
  <div
    class="bg-white overlay-background fixed top-0 left-0 h-100 w-100 z-2 flex justify-center"
  >
    <pl-button
      class="flex pl-secondary-font flex-column justify-center"
      style="height: 30px; padding: 0 0 0 6px;"
      @click.native="closePage"
      :style="{ margin: centeredTitle ? '20px auto' : '20px 0px' }"
    >
      <span class="pl-title">
        <i class="ma1 fa fa-arrow-left"></i>
        Back
      </span>
    </pl-button>
    <article class="w-100 overflow-y-auto mt2">
      <div class="w-100 center" :style="{ 'max-width': pageWidth }"></div>
      <div class="ph3 pv4">
        <div class="center h-100" :style="{ 'max-width': pageWidth }">
          <div v-if="loading">
            <pl-spinner
              style="margin-left: auto; margin-right: auto;"
              class="x2"
            />
          </div>
          <slot v-else></slot>
        </div>
      </div>
    </article>
    <button
      @click="closePage"
      @mouseenter="hovered = true"
      @mouseleave="hovered = false"
      class="exit-comment-page ma2 top-0 right-0 flex justify-center middle-xs"
      :class="{ 'shadow-1': hovered }"
      style="margin: 5px 20px 0 20px;"
    >
      <img style="max-width: 20px;" src="/static/close.svg" alt="close" />
      <p class="absolute italics" style="top: 65px;">esc</p>
    </button>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  export default {
    data() {
      return {
        hovered: false,
      };
    },
    computed: {
      ...mapGetters(['getCurrentRT', 'getCourseDetail']),
    },
    props: {
      title: {
        type: String,
        default: '',
      },
      pageWidth: {
        type: String,
        default: '750px',
      },
      centeredTitle: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      closePage() {
        window.removeEventListener('keyup', this.escapeViewCommentPage);
        // const route = {
        //   name: 'roundtable.feed',
        //   params: {
        //     courseID: this.getCourseDetail.id.toString(),
        //     roundtableID: this.getCurrentRT.id.toString(),
        //   },
        // };
        // this.$router.push(route);
        this.$store.dispatch('userEnteredSummaryOverlay', false);
        return this.$emit('close');
      },
      escapeViewCommentPage(event) {
        if (event.keyCode === 27) {
          this.closePage();
        }
      },
    },
    mounted() {
      window.addEventListener('keyup', this.escapeViewCommentPage);
      EventBus.$on('goToStudentSubmissionPage', this.closePage);
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
  .exit-comment-page
    border-radius: 50%
    width: 80px
    height: 70px
    display: flex
    align-items: center
    justify-content: center

  ::-webkit-scrollbar {
    display: block;
    width: 10px
    -webkit-appearance: none;
  }
</style>



// WEBPACK FOOTER //
// fullscreenOverlay.vue?66e41d08